
import {switchMap} from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AppState } from '../../ngrx/state/app-state';
import { Store } from '@ngrx/store';
import { getFavoriteBoard } from '../../ngrx/reducers/default-collection.reducer';

@Component({
  selector: 'board-favorite-star',
  template: `<div class="star" favoriteToggler 
                  [boardId]="boardId$ | async" 
                  [isFavorite]="isFavorite$ | async" 
                  [class.active]="isFavorite$ | async"></div>`,
  styleUrls: ['./board-favorite-star.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BoardFavoriteStarComponent implements OnInit {
  @Input() boardId$: Observable<number>;

  public isFavorite$: Observable<boolean>;

  constructor(private _store: Store<AppState>) {}

  ngOnInit() {
    this.isFavorite$ = this.boardId$.pipe(switchMap(boardId => this._store.pipe((getFavoriteBoard(boardId)))));
  }
}
